import { actionConstants } from '../constants';
import {
  successReqActionType,
  failReqActionType,
  startReqActionType
} from 'helper/requestHelper';

const initialState = {
  error: null,
  sessions: [],
  customerId: '',
  isLoadingSessions: false,
  isLoadingSession: false,
  isUpdatingSession: false,
  currentSession: null
};

const applySessionUpdates = (session, sessionId, updates) => {
  if (!session) {
    return session;
  }
  const id = session.session_id || session.id;
  if (id !== sessionId) {
    return session;
  }
  return { ...session, ...updates };
};

const sessionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case startReqActionType(actionConstants.GET_SESSIONS):
      return {
        ...state,
        isLoadingSessions: true
      };
    case successReqActionType(actionConstants.GET_SESSIONS):
      return {
        ...state,
        isLoadingSessions: false,
        sessions: action.payload.sessions || [],
        customerId: action.payload.customer_id || ''
      };
    case failReqActionType(actionConstants.GET_SESSIONS):
      return {
        ...state,
        isLoadingSessions: false
      };

    case startReqActionType(actionConstants.GET_SESSION):
      return {
        ...state,
        isLoadingSession: true
      };
    case successReqActionType(actionConstants.GET_SESSION):
      return {
        ...state,
        isLoadingSession: false,
        currentSession: action.payload
      };
    case failReqActionType(actionConstants.GET_SESSION):
      return {
        ...state,
        isLoadingSession: false
      };

    case startReqActionType(actionConstants.UPDATE_SESSION):
      return {
        ...state,
        isUpdatingSession: true
      };
    case successReqActionType(actionConstants.UPDATE_SESSION): {
      const { session_id: sessionId, updates } = action.payload;
      return {
        ...state,
        isUpdatingSession: false,
        sessions: state.sessions.map(session =>
          applySessionUpdates(session, sessionId, updates)
        ),
        currentSession: applySessionUpdates(
          state.currentSession,
          sessionId,
          updates
        )
      };
    }
    case failReqActionType(actionConstants.UPDATE_SESSION):
      return {
        ...state,
        isUpdatingSession: false
      };

    case successReqActionType(actionConstants.DELETE_SESSION):
      return {
        ...state,
        sessions: state.sessions.filter(
          session => (session.session_id || session.id) !== action.payload
        ),
        currentSession:
          state.currentSession &&
          (state.currentSession.session_id || state.currentSession.id) ===
            action.payload
            ? null
            : state.currentSession
      };

    default:
      return state;
  }
};

export default sessionsReducer;
